import { ButtonBase, DialogContent, Paper, styled as muiStyled } from '@mui/material'
import styled from 'styled-components'

export const LayoutContainer = styled.div`
  width: 100%;
  display: flex;
  font-family: Outfit;
`

export const GenericDisplayFlex = styled.div`
  display: flex;
  align-items: center;
  ${(props) => props?.gap && `gap: ${props?.gap}px;`};
  ${(props) => props?.sb && 'justify-content: space-between;'};
  ${(props) => props?.center && 'justify-content: center;'};
  width: ${(props) => (props?.width ? props.width : 'unset')};
`

export const GenericDisplayFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => props?.aic && 'align-items: center;'};
  ${(props) => props?.jcc && 'justify-content: center;'};
`
export const KycPendingPaper = muiStyled(Paper)`
    font-family: 'Outfit';
    height: 100%;
    width: 100%;
    max-height: 500px !important;
    max-width: 530px !important;
    border-radius:15px ;
    text-align: center;
`
export const KycPendingContent = muiStyled(DialogContent)`
display: flex;
flex-direction: column;
justify-content: center;
gap: 40px;
align-items: center
`
export const KycIcon = muiStyled('img')`
    height: 100px;
    width: 100px;
`
export const KycText = muiStyled('div')`
    font-size: 20px;
    font-weight: 600;
`
export const KycSubText = muiStyled('div')`
    font-size: 16px;
`
export const KycProceedButton = muiStyled(ButtonBase)`
display: flex;
align-items: center;
justify-content: center;
gap: 10px;
background: #a864ff;
padding: 10px 58px;
color: white;
border-radius: 40px;
`
export const KycExploreAppButton = muiStyled(ButtonBase)`
padding: 10px 58px;
text-decoration: underline;
border-radius: 40px;
`

export const MentorAccessUnavailableContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  font-family: Outfit;
  background: #f8fafc;
`

export const MentorAccessUnavailablePanel = styled.div`
  width: min(100%, 560px);
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 32px;
  border: 1px solid #d8e0ea;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);

  @media (max-width: 600px) {
    padding: 24px;
  }
`

export const MentorAccessUnavailableIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9a3412;
  background: #ffedd5;
`

export const MentorAccessUnavailableTitle = styled.h1`
  margin: 0;
  color: #172033;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
`

export const MentorAccessUnavailableText = styled.p`
  margin: 0;
  color: #475569;
  font-size: 16px;
  line-height: 1.6;
`

export const MentorAccessUnavailablePortalSwitcher = styled.div`
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 12px 10px 16px;
  border: 1px solid #d8e0ea;
  border-radius: 8px;
  background: #f8fafc;
`

export const MentorAccessUnavailablePortalSwitcherText = styled.span`
  color: #334155;
  font-size: 15px;
  font-weight: 700;
`

export const MentorAccessUnavailableActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;
`

export const MentorAccessUnavailablePrimaryButton = muiStyled(ButtonBase)`
  min-height: 42px;
  padding: 10px 18px;
  border-radius: 6px;
  color: #ffffff;
  background: #235c51;
  font-family: Outfit;
  font-weight: 700;
`

export const MentorAccessUnavailableSecondaryButton = muiStyled(ButtonBase)`
  min-height: 42px;
  padding: 10px 18px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  color: #334155;
  background: #ffffff;
  font-family: Outfit;
  font-weight: 700;
`
